import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { localTime } from 'utils/unitConversion';

// components
import BasicModal from 'components/Modals/BasicModal';
import ModalHeader from 'components/Layout/ModalHeader';
import { getLogsAction } from 'redux/actions/task';
import Table from 'components/Tables/Table';
import TableRow from 'components/Tables/TableRow';
import { epochToReadable } from 'utils/unitConversion';

const LongLog = ({ activeTask, model, closeJobLogHandler }) => {
  const [dLogs, setDLogs] = useState([]);
  const [tableBodyLong, setTableBodyLong] = useState([]);
  const dispatch = useDispatch();
  const [loadingLogs, setLoadingLogs] = useState(true);

  const headersLong = [
    { headerName: 'Type', classes: 'w-[7.5%]' },
    { headerName: 'Timestamp', classes: 'w-[15%]' },
    { headerName: 'Tool ID', classes: 'w-[7.5%]' },
    { headerName: 'Message', classes: 'w-[30%]' },
    { headerName: 'Rows', classes: 'w-[5%]' },
    { headerName: 'Columns', classes: 'w-[5%]' },
    { headerName: 'Time', classes: 'w-[10%]' },
  ];

  useEffect(() => {
    const body = dLogs.map((data) => {
      const message = JSON.parse(data.message);
      return (
        <tr key={data?.id}>
          <td className="mx-2 text-center  justify-center w-[100px] h-full pb-1">
            <div
              className={`${message?.severity == 'info'
                ? 'bg-zinc-200 text-zinc-600 border-zinc-600'
                : message?.severity == 'action'
                  ? 'bg-green-50 text-green-600 border-green-600'
                  : message?.severity == 'error'
                    ? 'bg-red-50 text-red-600 border-red-600'
                    : message?.severity == 'warning'
                      ? 'bg-yellow-50 text-yellow-600 border-yellow-600'
                      : 'bg-blue-200'
                } m-2 w-[68px] h-auto inline-flex items-center tracking-wide border justify-center rounded-lg relative px-1 py-1 text-[10px] font-medium`}
            >
              <p className="px-1.5 py-0 uppercase">{message?.severity}</p>
            </div>
          </td>
          <TableRow content={<p>{epochToReadable(data?.timestamp)}</p>} />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.tool_id}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.message || message?.message}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.Records}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.Columns}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.Time}</p>}
          />
        </tr>
      );
    });
    setTableBodyLong(body);
  }, [dLogs]);

  const getLogs = async (taskId) => {
    const result = await dispatch(
      getLogsAction({ object_type: model.type, object_id: model.id, task_id: taskId })
    );
    setLoadingLogs(false);
    setDLogs(result.payload || []);
  };

  useEffect(() => {
    getLogs(activeTask.id);
  }, []);

  useEffect(() => {
    const body = dLogs.map((data) => {
      const message = JSON.parse(data.message);

      return (
        <tr key={data?.id}>
          <td className="mx-2 text-center  justify-center w-[100px] h-full pb-1">
            <div
              className={`${message?.severity == 'info'
                ? 'bg-zinc-200 text-zinc-600 border-zinc-600'
                : message?.severity == 'action'
                  ? 'bg-green-50 text-green-600 border-green-600'
                  : message?.severity == 'error'
                    ? 'bg-red-50 text-red-600 border-red-600'
                    : message?.severity == 'warning'
                      ? 'bg-yellow-50 text-yellow-600 border-yellow-600'
                      : 'bg-blue-200'
                } m-2 w-[68px] h-auto inline-flex items-center tracking-wide border justify-center rounded-lg relative px-1 py-1 text-[10px] font-medium`}
            >
              <p className="px-1.5 py-0 uppercase">{message?.severity}</p>
            </div>
          </td>
          <TableRow content={<p>{epochToReadable(data?.timestamp)}</p>} />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.tool_id}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.message || message?.message}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.Records}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.Columns}</p>}
          />
          <TableRow
            classes="!whitespace-normal break-words"
            content={<p>{message?.message?.Time}</p>}
          />
        </tr>
      );
    });
    setTableBodyLong(body);
  }, [dLogs]);

  function closeJobLog() {
    closeJobLogHandler();
    setDLogs([]);
    setLoadingLogs(true);
  }

  return (
    <>
      <BasicModal
        open
        classes="w-[1000px] 2xl:w-[1200px] min-w-lg"
        onClose={() => closeJobLog()}
        content={
          <div className="p-8">
            <ModalHeader
              header={`Executed at: ${localTime(activeTask?.executed_at || activeTask?.created_at)}`}
              content={<>
                <p className="mt-2 max-w-4xl text-sm align-baseline">Model: {model?.name}</p>
              </>
              }
            />

            <div className="mt-3 ">
              <Table
                {...{
                  classes: '!max-h-[calc(90vh-225px)]',
                  headers: headersLong,
                  tableBody: tableBodyLong,
                  pager: { size: 25 },
                  emptyMessage: loadingLogs ? 'Loading' : 'No Logs found for this job',
                }}
              />
            </div>
          </div>
        }
      />
    </>
  );
};

LongLog.propTypes = {
  activeTask: PropTypes.any,
  model: PropTypes.any,
  closeJobLogHandler: PropTypes.func,
};

LongLog.defaultProps = {
  activeTask: {},
  model: {},
};

export default LongLog;
